import { en } from "./en";
import { fr } from "./fr";

export const translations: Record<Locale, Translations> = { en, fr };

